import React from "react";
import { apiGet, apiPost } from "../api";

export const LoggedInUserContext = React.createContext([]);

// Polling cadence: fast when signed in (so session changes propagate quickly),
// slow when anonymous (reduces 401 noise + server load on homepage).
const SIGNED_IN_POLL_MS = 60_000;
const ANONYMOUS_POLL_MS = 5 * 60_000;

const UnnamedComponent = (props) => {
  const [signedIn, setSignedIn] = React.useState(false);
  const [currentUser, setCurrentUser] = React.useState();
  const [loading, setLoading] = React.useState(true);

  const refreshUser = React.useCallback(async () => {
    const { parsedResponse } = await apiGet("/api/v1/users/logged_in");
    if (parsedResponse?.user) {
      setCurrentUser(parsedResponse.user);
      setSignedIn(true);
    } else {
      setCurrentUser(null);
      setSignedIn(false);
    }
    setLoading(false);
  }, []);

  const performLogout = React.useCallback(async () => {
    await apiPost("/api/v1/auth/logout");
    setCurrentUser(null);
    setSignedIn(false);
  }, []);

  // Poll on an interval whose length depends on current auth state.
  React.useEffect(() => {
    refreshUser();
    const interval = signedIn ? SIGNED_IN_POLL_MS : ANONYMOUS_POLL_MS;
    const t = setInterval(refreshUser, interval);
    return () => clearInterval(t);
  }, [signedIn, refreshUser]);

  const passed = React.useMemo(
    () => ({ loading, signedIn, currentUser, performLogout, refreshUser }),
    [loading, signedIn, currentUser, performLogout, refreshUser],
  );

  return (
    <LoggedInUserContext value={passed}>{props.children}</LoggedInUserContext>
  );
};

export default UnnamedComponent;
